__turbopack_context__.v({
  "active": "Tag-module-scss-module__feuXEW__active",
  "default": "Tag-module-scss-module__feuXEW__default",
  "icon": "Tag-module-scss-module__feuXEW__icon",
  "inactive": "Tag-module-scss-module__feuXEW__inactive",
  "md": "Tag-module-scss-module__feuXEW__md",
  "primary": "Tag-module-scss-module__feuXEW__primary",
  "primaryWithIcon": "Tag-module-scss-module__feuXEW__primaryWithIcon",
  "root": "Tag-module-scss-module__feuXEW__root",
  "secondary": "Tag-module-scss-module__feuXEW__secondary",
  "value": "Tag-module-scss-module__feuXEW__value",
});
